module.exports = __webpack_public_path__ + "static/media/loading-circle.cf5b3d2f.svg";